module.exports = __webpack_public_path__ + "static/img/img_service.317a68c3.png";